import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { Doc } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetDoc = (caseId: string, docId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Doc>(
    [QueryEntity.Doc, { docId }],
    () => {
      return fetch(`${APIBaseChronos}/api/case/${caseId}/docs/${docId}`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    {
      refetchOnWindowFocus: false,
    },
  );
};
